// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyAcBzK-nDma-GG5ByshF_KwzH-t8DDS_Ew",
  authDomain: "fundadocentejdd-990b8.firebaseapp.com",
  projectId: "fundadocentejdd-990b8",
  storageBucket: "fundadocentejdd-990b8.appspot.com",
  messagingSenderId: "1074200754861",
  appId: "1:1074200754861:web:12f87d3f3c7cbf5527e424"
};

// Initialize Firebase
const firebaseApp = initializeApp(firebaseConfig);
export const db = getFirestore(firebaseApp);

export default firebaseApp;